export type RepartitionData = {
  _id: string
  value: number
}

export type VisitorEvolutionData = {
  date: Date,
  value: {
    new: number
    returning: number
  }
}

export type ActiveEvolutionData = {
  date: Date
  value: number
}

export type Indicators = {
  users: number
  uniqUsers: number
  avgTrx: number
  avgPaid: number
  avgOrder: number
  avgEarnings: number
}

export const initialIndicators = {
  users: 0,
  uniqUsers: 0,
  avgTrx: 0,
  avgPaid: 0,
  avgOrder: 0,
  avgEarnings: 0
}
